import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import BellNotifiaction from '../BellNotifiaction'
import PostsOfSpiceProducts from '../PostofspiceProduct';

export default function SpiceProduct() {
    const [fname13, setfname13] = useState("");
    const [SpiceProductDescription, setSpiceProductDescription] = useState("");
    const [newFile13, setnewFile13] = useState(null);
    const [newdata13, setNewData13] = useState([]);
  
  
  
    const setData13 = (e) => {
      const { value } = e.target;
      setfname13(value);
    };
    const setData15 = (e) => {
      const { value } = e.target;
      setSpiceProductDescription(value);
    };
    const setimgfile = (e) => {
      setnewFile13(e.target.files[0]);
    };
  
    // Add image
  
    const addUserData13 = async (e) => {
      
      var formData13 = new FormData();
      console.log(newFile13);
      var filename = newFile13.name;
      formData13.append("photo13", newFile13, filename);
      formData13.append("fname13", fname13);
      formData13.append("SpiceProductDescription", SpiceProductDescription);
      console.log(formData13);
  
      const config = {
        headers: {
          "Content-Type": " multipart/form-data",
        },
      };
  
      const res = await axios.post(
        "https://pratik-agro-backend.vercel.app/AddSpiceProductimg",
        formData13,
        config
      );
  
      console.log(res);
    };
    //get image
  
    const getUserData12 = async () => {
      const res13 = await axios.get("https://pratik-agro-backend.vercel.app/getSpiceProductimg", {
        headers: {
          "Content-Type": " application/json",
        },
      });
      if (res13.data.status === 401 || !res13.data) {
        console.log("error");
      } else {
        setNewData13(res13.data.getImage.reverse());
      }
    };
    useEffect(() => {
      getUserData12();
    }, []);
   
  //delete data
  const deleteimage = async (id) => {
   
    const res6 = await fetch(`https://pratik-agro-backend.vercel.app/deletedata13/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const deleteStud = await res6.json();
    console.log(deleteStud);
    if (res6.status === 422 || !deleteStud) {
      console.log("error");
    } else {
      getUserData12();
    }
  
  };
  return (
    <div className='content'>
     <div className="mt-2 mb-1 d-flex justify-content-between align-items-center">
        <i>
          <h2>Product</h2>
        </i>
       <div>
     
       <BellNotifiaction />
       <Link
          type="button"
          to="/Addhomeimage"
          className="btn btn-light shadow addimage "
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          Add Image
        </Link>
       </div>
        
        
      </div>
      <div className=" container text-end mt-5">
        {/* <Link  to="/Addhomeimage"className="btn btn-success "> Add Data</Link> */}
        
        <div
          class="modal fade "
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog ">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">
                  Spices Products
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form>
                  <div>
                    
                      <p style={{float:'left'}}>Product Image Name:-</p>
                    
                    <input
                      type="text"
                      name="fname13"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setData13}
                    />
                     <p style={{float:'left'}}>Description:-</p>
                    
                    <input
                      type="text"
                      name="SpiceProductDescription"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setData15}
                    />

                    <div>
                      <p style={{float:'left'}}>Add Your Image:-</p>
                    </div>
                    <input
                      type="file"
                      name="photo13"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setimgfile}
                    />
                    <button
                      type="submit"
                      className="btn btn-primary mt-5"
                       onClick={addUserData13}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
        
        
        
          <PostsOfSpiceProducts posts={newdata13} deleteimage={deleteimage}/>
        
     
    </div>
  )
}
